module.exports = __webpack_public_path__ + "static/media/newHorizonLogo.48723789.jpeg";